module.exports = __webpack_public_path__ + "img/grouping1.png";